import {PlayerSize} from '../enums/PlayerSize';
import {StreamTypes} from '../enums/StreamTypes';
import {isNullish} from '../utils/Utils';

export interface PlaybackInfo {
  audioBitrate?: number;
  audioCodec?: string;
  audioLanguage?: string;
  castTech?: string;
  droppedFrames: number;
  isCasting?: boolean;
  isLive?: boolean;
  isMuted?: boolean;
  m3u8Url?: string;
  mpdUrl?: string;
  playerTech?: string;
  progUrl?: string;
  screenHeight?: number;
  screenWidth?: number;
  size?: PlayerSize;
  streamFormat?: string;
  subtitleEnabled?: boolean;
  subtitleLanguage?: string;
  videoBitrate?: number;
  videoCodec?: string;
  videoDuration?: number;
  videoPlaybackHeight?: number;
  videoPlaybackWidth?: number;
  videoTitle?: string;
  videoWindowHeight?: number;
  videoWindowWidth?: number;
}

export function normalizeVideoDuration(playerVideoDuration: number | null | undefined): number {
  // This covers Live streams and any case in which the duration is not known
  // which should report 0 as videoDuration
  if (isNullish(playerVideoDuration) || Number.isNaN(playerVideoDuration) || playerVideoDuration === Infinity) {
    return 0;
  }
  return playerVideoDuration;
}

export function buildPlaybackInfoStreamTypeFields(
  streamType: StreamTypes | undefined,
  streamUrl: string | undefined,
): Pick<PlaybackInfo, 'm3u8Url' | 'mpdUrl' | 'progUrl' | 'streamFormat'> {
  const DEFAULT_RESULT = {
    // set the stream type as it is (except null, that should be converted to undefined)
    streamFormat: streamType ?? undefined,
    // If the stream url is there, set it as "progUrl", even when the stream type is not recognized (unknown / nullish).
    // Why?
    //  There was no clear reason why when this utility fn was created, it was just current written code/behavior
    //  of our adapters, and for that reason it was copy&pasted here.
    progUrl: streamUrl,
  };

  if (isNullish(streamType)) {
    return DEFAULT_RESULT;
  }

  if (streamType === StreamTypes.dash) {
    return {streamFormat: streamType, mpdUrl: streamUrl};
  }
  if (streamType === StreamTypes.hls) {
    return {streamFormat: streamType, m3u8Url: streamUrl};
  }
  if (streamType === StreamTypes.prog) {
    return {streamFormat: streamType, progUrl: streamUrl};
  }

  return DEFAULT_RESULT;
}
